import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { hide } from './utils';

export default function* listenHide() {
  yield takeEvery(actionTypes.HIDE, hide);
}
